// extracted by mini-css-extract-plugin
module.exports = {"main":"Home_main__3EE37","navBar":"Home_navBar__1PZcM","min":"Home_min__2HnOM","logo":"Home_logo__3FG2P","buttons":"Home_buttons__3fd9R","footer":"Home_footer__1RpMR"};